import styled, { css } from 'styled-components';

/**
 * BEC-24811: CMSSection only sets margin-bottom, so a CMS-placed carousel gets its.
 */
export const Wrapper = styled.div`
  &:empty {
    display: none;
  }

  ${({ theme }) => css`
    margin-top: ${theme.spacing(5)};

    ${theme.media.sm.up} {
      margin-top: ${theme.spacing(6)};
    }
  `}
`;
